import { render, staticRenderFns } from "./DiscreteStudyID.vue?vue&type=template&id=3af8eecf&scoped=true&"
import script from "./DiscreteStudyID.vue?vue&type=script&lang=js&"
export * from "./DiscreteStudyID.vue?vue&type=script&lang=js&"
import style0 from "./DiscreteStudyID.vue?vue&type=style&index=0&id=3af8eecf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af8eecf",
  null
  
)

export default component.exports